import { Routes, Route } from "react-router-dom";
import Header from "./components/Common/Header/Header";
import Footer from "./components/Common/Footer/Footer";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Enquiry from "./pages/Enquiry/Enquiry";
import Contact from "./pages/Contact/Contact";
import Faq from "./pages/Faq/Faq";
import Benefits from "./pages/Benefits/Benefits";
import Gallery from "./components/Gallery/Gallery";
import Login from "./pages/Auth/login";


import "./App.css";
import Enquiries from "./pages/Admin/Enquiries/Enquiries";
import Leads from "./pages/Admin/Leads/Leads";
import ProtectedRoute from "./utils/ProtectedRoute";
import ScrollToTop from "./utils/ScrollToTop";
import ManageFolders from "./pages/Admin/ManageFolders/ManageFolders";
import ManageGallery from "./pages/Admin/ManageImages/ManageGallery";
import TermsConditions from "./pages/TermsConditions/TermsConditions";

function App() {
  return (
    <div className="app-shell">
      <Header />

      <ScrollToTop />

      <main className="app-content">
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/login" element={<Login />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />

          {/* PROTECTED ROUTES */}
          <Route
            path="/leads/enquirylist"
            element={
              <ProtectedRoute>
                <Enquiries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads/contactlist"
            element={
              <ProtectedRoute>
                <Leads />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/manage-folders"
            element={
              <ProtectedRoute>
                <ManageFolders />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/manage-images"
            element={
              <ProtectedRoute>
                <ManageGallery/>
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
